/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateUser = /* GraphQL */ `subscription OnCreateUser(
  $filter: ModelSubscriptionUserFilterInput
  $tenantId: String
  $id: String
) {
  onCreateUser(filter: $filter, tenantId: $tenantId, id: $id) {
    id
    cognitoSubId
    tenantId
    email
    givenName
    phoneNumber
    familyName
    meetingId
    defaultFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    lockedFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    defaultFilterValues {
      key
      values
      __typename
    }
    lockedFilters {
      key
      values
      __typename
    }
    shareBCC
    shareCC
    createdAt
    createdBy
    updatedAt
    status
    role
    bookmarkedDocs {
      docID
      createdAt
      __typename
    }
    bookmarkedFolders {
      folderID
      createdAt
      __typename
    }
    isExcludedFromReporting
    additionalRoles
    altUsername
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserSubscriptionVariables,
  APITypes.OnCreateUserSubscription
>;
export const onUpdateUser = /* GraphQL */ `subscription OnUpdateUser(
  $filter: ModelSubscriptionUserFilterInput
  $tenantId: String
  $id: String
) {
  onUpdateUser(filter: $filter, tenantId: $tenantId, id: $id) {
    id
    cognitoSubId
    tenantId
    email
    givenName
    phoneNumber
    familyName
    meetingId
    defaultFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    lockedFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    defaultFilterValues {
      key
      values
      __typename
    }
    lockedFilters {
      key
      values
      __typename
    }
    shareBCC
    shareCC
    createdAt
    createdBy
    updatedAt
    status
    role
    bookmarkedDocs {
      docID
      createdAt
      __typename
    }
    bookmarkedFolders {
      folderID
      createdAt
      __typename
    }
    isExcludedFromReporting
    additionalRoles
    altUsername
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserSubscriptionVariables,
  APITypes.OnUpdateUserSubscription
>;
export const onDeleteUser = /* GraphQL */ `subscription OnDeleteUser(
  $filter: ModelSubscriptionUserFilterInput
  $tenantId: String
  $id: String
) {
  onDeleteUser(filter: $filter, tenantId: $tenantId, id: $id) {
    id
    cognitoSubId
    tenantId
    email
    givenName
    phoneNumber
    familyName
    meetingId
    defaultFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    lockedFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    defaultFilterValues {
      key
      values
      __typename
    }
    lockedFilters {
      key
      values
      __typename
    }
    shareBCC
    shareCC
    createdAt
    createdBy
    updatedAt
    status
    role
    bookmarkedDocs {
      docID
      createdAt
      __typename
    }
    bookmarkedFolders {
      folderID
      createdAt
      __typename
    }
    isExcludedFromReporting
    additionalRoles
    altUsername
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserSubscriptionVariables,
  APITypes.OnDeleteUserSubscription
>;
export const onCreateTenant = /* GraphQL */ `subscription OnCreateTenant(
  $filter: ModelSubscriptionTenantFilterInput
  $id: String
) {
  onCreateTenant(filter: $filter, id: $id) {
    id
    name
    licensedUsers
    licensedViewOnlyUsers
    status
    folderUpdateGracePeriodDays
    medInfoURL
    medInfoLabel
    featureFlags {
      flagId
      value
      __typename
    }
    createdAt
    createdBy
    updatedAt
    statusChangedAt
    statusChangedBy
    ssoDomains
    integrations
    config {
      requiredSlidesHiddenMessage
      aiSearchDisclaimer
      forms {
        id
        name
        label
        fields {
          id
          fieldName
          fieldLabel
          reportingName
          status
          description
          required
          maxLength
          formatValidation
          fieldType
          showByDefault
          dependentFieldId
          controlType
          order
          settings {
            isBadge
            fieldPosition
            __typename
          }
          usage
          action
          actionSkip
          documentSettings {
            fieldPosition
            __typename
          }
          fieldValueDefinitions {
            id
            value
            label
            disabled
            isDefault
            documentSettings {
              presentationWatermarkText
              permission {
                present
                modify
                share
                download
                externalNotation
                __typename
              }
              __typename
            }
            disabledUserPermissions
            badgeColor
            badgeLabel
            createdAt
            dependentValueIds
            __typename
          }
          displayOnParentSelection
          displayOnValueSelection
          objectSetting {
            childrenFieldIds
            restriction {
              syncUpdate
              syncDelete
              update
              delete
              __typename
            }
            __typename
          }
          isChildField
          dateRestriction
          createdAt
          scaleNumber
          precisionNumber
          __typename
        }
        targetRequestTemplate
        targetType
        targetAddress
        targetParameters {
          key
          value
          __typename
        }
        status
        __typename
      }
      customFields {
        id
        fieldName
        fieldLabel
        reportingName
        status
        description
        required
        maxLength
        formatValidation
        fieldType
        showByDefault
        dependentFieldId
        controlType
        order
        settings {
          isBadge
          fieldPosition
          __typename
        }
        usage
        action
        actionSkip
        documentSettings {
          fieldPosition
          __typename
        }
        fieldValueDefinitions {
          id
          value
          label
          disabled
          isDefault
          documentSettings {
            presentationWatermarkText
            permission {
              present
              modify
              share
              download
              externalNotation
              __typename
            }
            __typename
          }
          disabledUserPermissions
          badgeColor
          badgeLabel
          createdAt
          dependentValueIds
          __typename
        }
        displayOnParentSelection
        displayOnValueSelection
        objectSetting {
          childrenFieldIds
          restriction {
            syncUpdate
            syncDelete
            update
            delete
            __typename
          }
          __typename
        }
        isChildField
        dateRestriction
        createdAt
        scaleNumber
        precisionNumber
        __typename
      }
      customStyle {
        color {
          primary
          __typename
        }
        __typename
      }
      defaultDocumentPermissions {
        present
        modify
        share
        download
        externalNotation
        __typename
      }
      mslListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      publisherListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      crmIntegration {
        id
        crmIntegrationType
        instanceUrl
        clientId
        redirectUri
        name
        accountsSettings {
          query
          displaySettings {
            shortened
            extended
            __typename
          }
          addressSettings {
            alias
            displaySettings {
              shortened
              extended
              __typename
            }
            __typename
          }
          __typename
        }
        meetingSetting {
          apiName
          presentationsFieldName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          __typename
        }
        additionalSettings {
          refreshSessionIntervalInMinutes
          allowCommentsOnTasks
          detailContentTableSettings {
            name
            apiName
            relationshipName
            prefix
            __typename
          }
          enableSurveys
          crmAccountToObjectSettings {
            accountFieldNames {
              accountFieldName
              objectFieldName
              __typename
            }
            apiName
            __typename
          }
          __typename
        }
        loginUrl
        externalOidcSso {
          issuer
          authorizationEndpoint
          tokenEndpoint
          clientId
          redirectUri
          vaultSessionEndpoint
          scope
          __typename
        }
        crmStandaloneForms {
          id
          apiName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          parents {
            apiName
            relationshipName
            __typename
          }
          usage
          __typename
        }
        __typename
      }
      sessionTimeout
      quickFilters {
        id
        label
        path
        __typename
      }
      hubsConfig {
        shareExpirationDays
        disabledSections
        disableNotationDescription
        __typename
      }
      reports {
        key
        value
        __typename
      }
      emailDocumentUpdateFrequency
      emailReportConfig {
        type
        frequency
        recipients
        customFieldColumns
        __typename
      }
      sharePPTXasPDF
      customDeckAcknowledgement {
        shouldShow
        content
        __typename
      }
      preferredBeaconDomain
      namedFilter {
        name
        filter {
          fieldId
          valueId
          __typename
        }
        __typename
      }
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTenantSubscriptionVariables,
  APITypes.OnCreateTenantSubscription
>;
export const onUpdateTenant = /* GraphQL */ `subscription OnUpdateTenant(
  $filter: ModelSubscriptionTenantFilterInput
  $id: String
) {
  onUpdateTenant(filter: $filter, id: $id) {
    id
    name
    licensedUsers
    licensedViewOnlyUsers
    status
    folderUpdateGracePeriodDays
    medInfoURL
    medInfoLabel
    featureFlags {
      flagId
      value
      __typename
    }
    createdAt
    createdBy
    updatedAt
    statusChangedAt
    statusChangedBy
    ssoDomains
    integrations
    config {
      requiredSlidesHiddenMessage
      aiSearchDisclaimer
      forms {
        id
        name
        label
        fields {
          id
          fieldName
          fieldLabel
          reportingName
          status
          description
          required
          maxLength
          formatValidation
          fieldType
          showByDefault
          dependentFieldId
          controlType
          order
          settings {
            isBadge
            fieldPosition
            __typename
          }
          usage
          action
          actionSkip
          documentSettings {
            fieldPosition
            __typename
          }
          fieldValueDefinitions {
            id
            value
            label
            disabled
            isDefault
            documentSettings {
              presentationWatermarkText
              permission {
                present
                modify
                share
                download
                externalNotation
                __typename
              }
              __typename
            }
            disabledUserPermissions
            badgeColor
            badgeLabel
            createdAt
            dependentValueIds
            __typename
          }
          displayOnParentSelection
          displayOnValueSelection
          objectSetting {
            childrenFieldIds
            restriction {
              syncUpdate
              syncDelete
              update
              delete
              __typename
            }
            __typename
          }
          isChildField
          dateRestriction
          createdAt
          scaleNumber
          precisionNumber
          __typename
        }
        targetRequestTemplate
        targetType
        targetAddress
        targetParameters {
          key
          value
          __typename
        }
        status
        __typename
      }
      customFields {
        id
        fieldName
        fieldLabel
        reportingName
        status
        description
        required
        maxLength
        formatValidation
        fieldType
        showByDefault
        dependentFieldId
        controlType
        order
        settings {
          isBadge
          fieldPosition
          __typename
        }
        usage
        action
        actionSkip
        documentSettings {
          fieldPosition
          __typename
        }
        fieldValueDefinitions {
          id
          value
          label
          disabled
          isDefault
          documentSettings {
            presentationWatermarkText
            permission {
              present
              modify
              share
              download
              externalNotation
              __typename
            }
            __typename
          }
          disabledUserPermissions
          badgeColor
          badgeLabel
          createdAt
          dependentValueIds
          __typename
        }
        displayOnParentSelection
        displayOnValueSelection
        objectSetting {
          childrenFieldIds
          restriction {
            syncUpdate
            syncDelete
            update
            delete
            __typename
          }
          __typename
        }
        isChildField
        dateRestriction
        createdAt
        scaleNumber
        precisionNumber
        __typename
      }
      customStyle {
        color {
          primary
          __typename
        }
        __typename
      }
      defaultDocumentPermissions {
        present
        modify
        share
        download
        externalNotation
        __typename
      }
      mslListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      publisherListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      crmIntegration {
        id
        crmIntegrationType
        instanceUrl
        clientId
        redirectUri
        name
        accountsSettings {
          query
          displaySettings {
            shortened
            extended
            __typename
          }
          addressSettings {
            alias
            displaySettings {
              shortened
              extended
              __typename
            }
            __typename
          }
          __typename
        }
        meetingSetting {
          apiName
          presentationsFieldName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          __typename
        }
        additionalSettings {
          refreshSessionIntervalInMinutes
          allowCommentsOnTasks
          detailContentTableSettings {
            name
            apiName
            relationshipName
            prefix
            __typename
          }
          enableSurveys
          crmAccountToObjectSettings {
            accountFieldNames {
              accountFieldName
              objectFieldName
              __typename
            }
            apiName
            __typename
          }
          __typename
        }
        loginUrl
        externalOidcSso {
          issuer
          authorizationEndpoint
          tokenEndpoint
          clientId
          redirectUri
          vaultSessionEndpoint
          scope
          __typename
        }
        crmStandaloneForms {
          id
          apiName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          parents {
            apiName
            relationshipName
            __typename
          }
          usage
          __typename
        }
        __typename
      }
      sessionTimeout
      quickFilters {
        id
        label
        path
        __typename
      }
      hubsConfig {
        shareExpirationDays
        disabledSections
        disableNotationDescription
        __typename
      }
      reports {
        key
        value
        __typename
      }
      emailDocumentUpdateFrequency
      emailReportConfig {
        type
        frequency
        recipients
        customFieldColumns
        __typename
      }
      sharePPTXasPDF
      customDeckAcknowledgement {
        shouldShow
        content
        __typename
      }
      preferredBeaconDomain
      namedFilter {
        name
        filter {
          fieldId
          valueId
          __typename
        }
        __typename
      }
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTenantSubscriptionVariables,
  APITypes.OnUpdateTenantSubscription
>;
export const onDeleteTenant = /* GraphQL */ `subscription OnDeleteTenant(
  $filter: ModelSubscriptionTenantFilterInput
  $id: String
) {
  onDeleteTenant(filter: $filter, id: $id) {
    id
    name
    licensedUsers
    licensedViewOnlyUsers
    status
    folderUpdateGracePeriodDays
    medInfoURL
    medInfoLabel
    featureFlags {
      flagId
      value
      __typename
    }
    createdAt
    createdBy
    updatedAt
    statusChangedAt
    statusChangedBy
    ssoDomains
    integrations
    config {
      requiredSlidesHiddenMessage
      aiSearchDisclaimer
      forms {
        id
        name
        label
        fields {
          id
          fieldName
          fieldLabel
          reportingName
          status
          description
          required
          maxLength
          formatValidation
          fieldType
          showByDefault
          dependentFieldId
          controlType
          order
          settings {
            isBadge
            fieldPosition
            __typename
          }
          usage
          action
          actionSkip
          documentSettings {
            fieldPosition
            __typename
          }
          fieldValueDefinitions {
            id
            value
            label
            disabled
            isDefault
            documentSettings {
              presentationWatermarkText
              permission {
                present
                modify
                share
                download
                externalNotation
                __typename
              }
              __typename
            }
            disabledUserPermissions
            badgeColor
            badgeLabel
            createdAt
            dependentValueIds
            __typename
          }
          displayOnParentSelection
          displayOnValueSelection
          objectSetting {
            childrenFieldIds
            restriction {
              syncUpdate
              syncDelete
              update
              delete
              __typename
            }
            __typename
          }
          isChildField
          dateRestriction
          createdAt
          scaleNumber
          precisionNumber
          __typename
        }
        targetRequestTemplate
        targetType
        targetAddress
        targetParameters {
          key
          value
          __typename
        }
        status
        __typename
      }
      customFields {
        id
        fieldName
        fieldLabel
        reportingName
        status
        description
        required
        maxLength
        formatValidation
        fieldType
        showByDefault
        dependentFieldId
        controlType
        order
        settings {
          isBadge
          fieldPosition
          __typename
        }
        usage
        action
        actionSkip
        documentSettings {
          fieldPosition
          __typename
        }
        fieldValueDefinitions {
          id
          value
          label
          disabled
          isDefault
          documentSettings {
            presentationWatermarkText
            permission {
              present
              modify
              share
              download
              externalNotation
              __typename
            }
            __typename
          }
          disabledUserPermissions
          badgeColor
          badgeLabel
          createdAt
          dependentValueIds
          __typename
        }
        displayOnParentSelection
        displayOnValueSelection
        objectSetting {
          childrenFieldIds
          restriction {
            syncUpdate
            syncDelete
            update
            delete
            __typename
          }
          __typename
        }
        isChildField
        dateRestriction
        createdAt
        scaleNumber
        precisionNumber
        __typename
      }
      customStyle {
        color {
          primary
          __typename
        }
        __typename
      }
      defaultDocumentPermissions {
        present
        modify
        share
        download
        externalNotation
        __typename
      }
      mslListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      publisherListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      crmIntegration {
        id
        crmIntegrationType
        instanceUrl
        clientId
        redirectUri
        name
        accountsSettings {
          query
          displaySettings {
            shortened
            extended
            __typename
          }
          addressSettings {
            alias
            displaySettings {
              shortened
              extended
              __typename
            }
            __typename
          }
          __typename
        }
        meetingSetting {
          apiName
          presentationsFieldName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          __typename
        }
        additionalSettings {
          refreshSessionIntervalInMinutes
          allowCommentsOnTasks
          detailContentTableSettings {
            name
            apiName
            relationshipName
            prefix
            __typename
          }
          enableSurveys
          crmAccountToObjectSettings {
            accountFieldNames {
              accountFieldName
              objectFieldName
              __typename
            }
            apiName
            __typename
          }
          __typename
        }
        loginUrl
        externalOidcSso {
          issuer
          authorizationEndpoint
          tokenEndpoint
          clientId
          redirectUri
          vaultSessionEndpoint
          scope
          __typename
        }
        crmStandaloneForms {
          id
          apiName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          parents {
            apiName
            relationshipName
            __typename
          }
          usage
          __typename
        }
        __typename
      }
      sessionTimeout
      quickFilters {
        id
        label
        path
        __typename
      }
      hubsConfig {
        shareExpirationDays
        disabledSections
        disableNotationDescription
        __typename
      }
      reports {
        key
        value
        __typename
      }
      emailDocumentUpdateFrequency
      emailReportConfig {
        type
        frequency
        recipients
        customFieldColumns
        __typename
      }
      sharePPTXasPDF
      customDeckAcknowledgement {
        shouldShow
        content
        __typename
      }
      preferredBeaconDomain
      namedFilter {
        name
        filter {
          fieldId
          valueId
          __typename
        }
        __typename
      }
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTenantSubscriptionVariables,
  APITypes.OnDeleteTenantSubscription
>;
export const onCreateUserSettings = /* GraphQL */ `subscription OnCreateUserSettings(
  $filter: ModelSubscriptionUserSettingsFilterInput
  $userId: String
) {
  onCreateUserSettings(filter: $filter, userId: $userId) {
    id
    userId
    tenantId
    analyticsFeed {
      documentsViewed {
        maxCount
        events {
          entityId
          timestamp
          __typename
        }
        __typename
      }
      foldersViewed {
        maxCount
        events {
          entityId
          timestamp
          __typename
        }
        __typename
      }
      __typename
    }
    viewedBulletinIds
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserSettingsSubscriptionVariables,
  APITypes.OnCreateUserSettingsSubscription
>;
export const onUpdateUserSettings = /* GraphQL */ `subscription OnUpdateUserSettings(
  $filter: ModelSubscriptionUserSettingsFilterInput
  $userId: String
) {
  onUpdateUserSettings(filter: $filter, userId: $userId) {
    id
    userId
    tenantId
    analyticsFeed {
      documentsViewed {
        maxCount
        events {
          entityId
          timestamp
          __typename
        }
        __typename
      }
      foldersViewed {
        maxCount
        events {
          entityId
          timestamp
          __typename
        }
        __typename
      }
      __typename
    }
    viewedBulletinIds
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserSettingsSubscriptionVariables,
  APITypes.OnUpdateUserSettingsSubscription
>;
export const onDeleteUserSettings = /* GraphQL */ `subscription OnDeleteUserSettings(
  $filter: ModelSubscriptionUserSettingsFilterInput
  $userId: String
) {
  onDeleteUserSettings(filter: $filter, userId: $userId) {
    id
    userId
    tenantId
    analyticsFeed {
      documentsViewed {
        maxCount
        events {
          entityId
          timestamp
          __typename
        }
        __typename
      }
      foldersViewed {
        maxCount
        events {
          entityId
          timestamp
          __typename
        }
        __typename
      }
      __typename
    }
    viewedBulletinIds
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserSettingsSubscriptionVariables,
  APITypes.OnDeleteUserSettingsSubscription
>;
export const onCreateDocumentVersion = /* GraphQL */ `subscription OnCreateDocumentVersion(
  $filter: ModelSubscriptionDocumentVersionFilterInput
  $tenantId: String
) {
  onCreateDocumentVersion(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDocumentVersionSubscriptionVariables,
  APITypes.OnCreateDocumentVersionSubscription
>;
export const onUpdateDocumentVersion = /* GraphQL */ `subscription OnUpdateDocumentVersion(
  $filter: ModelSubscriptionDocumentVersionFilterInput
  $tenantId: String
) {
  onUpdateDocumentVersion(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDocumentVersionSubscriptionVariables,
  APITypes.OnUpdateDocumentVersionSubscription
>;
export const onDeleteDocumentVersion = /* GraphQL */ `subscription OnDeleteDocumentVersion(
  $filter: ModelSubscriptionDocumentVersionFilterInput
  $tenantId: String
) {
  onDeleteDocumentVersion(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDocumentVersionSubscriptionVariables,
  APITypes.OnDeleteDocumentVersionSubscription
>;
export const onCreateAttachedFile = /* GraphQL */ `subscription OnCreateAttachedFile(
  $filter: ModelSubscriptionAttachedFileFilterInput
  $tenantId: String
) {
  onCreateAttachedFile(filter: $filter, tenantId: $tenantId) {
    id
    title
    tenantId
    documentId
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcFileName
    srcHash
    srcSize
    type
    editPermissions
    createdAt
    createdBy
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAttachedFileSubscriptionVariables,
  APITypes.OnCreateAttachedFileSubscription
>;
export const onUpdateAttachedFile = /* GraphQL */ `subscription OnUpdateAttachedFile(
  $filter: ModelSubscriptionAttachedFileFilterInput
  $tenantId: String
) {
  onUpdateAttachedFile(filter: $filter, tenantId: $tenantId) {
    id
    title
    tenantId
    documentId
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcFileName
    srcHash
    srcSize
    type
    editPermissions
    createdAt
    createdBy
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAttachedFileSubscriptionVariables,
  APITypes.OnUpdateAttachedFileSubscription
>;
export const onDeleteAttachedFile = /* GraphQL */ `subscription OnDeleteAttachedFile(
  $filter: ModelSubscriptionAttachedFileFilterInput
  $tenantId: String
) {
  onDeleteAttachedFile(filter: $filter, tenantId: $tenantId) {
    id
    title
    tenantId
    documentId
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcFileName
    srcHash
    srcSize
    type
    editPermissions
    createdAt
    createdBy
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAttachedFileSubscriptionVariables,
  APITypes.OnDeleteAttachedFileSubscription
>;
export const onCreateDocument = /* GraphQL */ `subscription OnCreateDocument(
  $filter: ModelSubscriptionDocumentFilterInput
  $tenantId: String
) {
  onCreateDocument(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    accessLevel
    status
    owner
    expiresAt
    integration {
      integrationId
      externalId
      firstSync
      lastSync
      __typename
    }
    integrationType
    type
    editPermissions
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDocumentSubscriptionVariables,
  APITypes.OnCreateDocumentSubscription
>;
export const onUpdateDocument = /* GraphQL */ `subscription OnUpdateDocument(
  $filter: ModelSubscriptionDocumentFilterInput
  $tenantId: String
) {
  onUpdateDocument(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    accessLevel
    status
    owner
    expiresAt
    integration {
      integrationId
      externalId
      firstSync
      lastSync
      __typename
    }
    integrationType
    type
    editPermissions
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDocumentSubscriptionVariables,
  APITypes.OnUpdateDocumentSubscription
>;
export const onDeleteDocument = /* GraphQL */ `subscription OnDeleteDocument(
  $filter: ModelSubscriptionDocumentFilterInput
  $tenantId: String
) {
  onDeleteDocument(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    accessLevel
    status
    owner
    expiresAt
    integration {
      integrationId
      externalId
      firstSync
      lastSync
      __typename
    }
    integrationType
    type
    editPermissions
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDocumentSubscriptionVariables,
  APITypes.OnDeleteDocumentSubscription
>;
export const onCreateEmailTemplate = /* GraphQL */ `subscription OnCreateEmailTemplate(
  $filter: ModelSubscriptionEmailTemplateFilterInput
  $tenantId: String
) {
  onCreateEmailTemplate(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    labelValues {
      key
      value
      __typename
    }
    customFilterValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    subject
    title
    cc
    bcc
    body
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    status
    editPermissions
    createdBy
    createdAt
    updatedBy
    updatedAt
    type
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateEmailTemplateSubscriptionVariables,
  APITypes.OnCreateEmailTemplateSubscription
>;
export const onUpdateEmailTemplate = /* GraphQL */ `subscription OnUpdateEmailTemplate(
  $filter: ModelSubscriptionEmailTemplateFilterInput
  $tenantId: String
) {
  onUpdateEmailTemplate(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    labelValues {
      key
      value
      __typename
    }
    customFilterValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    subject
    title
    cc
    bcc
    body
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    status
    editPermissions
    createdBy
    createdAt
    updatedBy
    updatedAt
    type
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateEmailTemplateSubscriptionVariables,
  APITypes.OnUpdateEmailTemplateSubscription
>;
export const onDeleteEmailTemplate = /* GraphQL */ `subscription OnDeleteEmailTemplate(
  $filter: ModelSubscriptionEmailTemplateFilterInput
  $tenantId: String
) {
  onDeleteEmailTemplate(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    labelValues {
      key
      value
      __typename
    }
    customFilterValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    subject
    title
    cc
    bcc
    body
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    status
    editPermissions
    createdBy
    createdAt
    updatedBy
    updatedAt
    type
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteEmailTemplateSubscriptionVariables,
  APITypes.OnDeleteEmailTemplateSubscription
>;
export const onCreateUserDocumentVersionSettings = /* GraphQL */ `subscription OnCreateUserDocumentVersionSettings(
  $filter: ModelSubscriptionUserDocumentVersionSettingsFilterInput
  $createdBy: String
) {
  onCreateUserDocumentVersionSettings(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    createdAt
    createdBy
    updatedAt
    updatedBy
    documentId
    documentVersionId
    customDeckId
    pageSettings {
      pageId
      hidden
      __typename
    }
    status
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserDocumentVersionSettingsSubscriptionVariables,
  APITypes.OnCreateUserDocumentVersionSettingsSubscription
>;
export const onUpdateUserDocumentVersionSettings = /* GraphQL */ `subscription OnUpdateUserDocumentVersionSettings(
  $filter: ModelSubscriptionUserDocumentVersionSettingsFilterInput
  $createdBy: String
) {
  onUpdateUserDocumentVersionSettings(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    createdAt
    createdBy
    updatedAt
    updatedBy
    documentId
    documentVersionId
    customDeckId
    pageSettings {
      pageId
      hidden
      __typename
    }
    status
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserDocumentVersionSettingsSubscriptionVariables,
  APITypes.OnUpdateUserDocumentVersionSettingsSubscription
>;
export const onDeleteUserDocumentVersionSettings = /* GraphQL */ `subscription OnDeleteUserDocumentVersionSettings(
  $filter: ModelSubscriptionUserDocumentVersionSettingsFilterInput
  $createdBy: String
) {
  onDeleteUserDocumentVersionSettings(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    createdAt
    createdBy
    updatedAt
    updatedBy
    documentId
    documentVersionId
    customDeckId
    pageSettings {
      pageId
      hidden
      __typename
    }
    status
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserDocumentVersionSettingsSubscriptionVariables,
  APITypes.OnDeleteUserDocumentVersionSettingsSubscription
>;
export const onCreateUserNotations = /* GraphQL */ `subscription OnCreateUserNotations(
  $filter: ModelSubscriptionUserNotationsFilterInput
  $createdBy: String
) {
  onCreateUserNotations(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    createdAt
    createdBy
    updatedAt
    updatedBy
    documentId
    documentVersionId
    customDeckId
    notation {
      id
      type
      description
      status
      pageId
      coordinate {
        x
        y
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    status
    type
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserNotationsSubscriptionVariables,
  APITypes.OnCreateUserNotationsSubscription
>;
export const onUpdateUserNotations = /* GraphQL */ `subscription OnUpdateUserNotations(
  $filter: ModelSubscriptionUserNotationsFilterInput
  $createdBy: String
) {
  onUpdateUserNotations(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    createdAt
    createdBy
    updatedAt
    updatedBy
    documentId
    documentVersionId
    customDeckId
    notation {
      id
      type
      description
      status
      pageId
      coordinate {
        x
        y
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    status
    type
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserNotationsSubscriptionVariables,
  APITypes.OnUpdateUserNotationsSubscription
>;
export const onDeleteUserNotations = /* GraphQL */ `subscription OnDeleteUserNotations(
  $filter: ModelSubscriptionUserNotationsFilterInput
  $createdBy: String
) {
  onDeleteUserNotations(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    createdAt
    createdBy
    updatedAt
    updatedBy
    documentId
    documentVersionId
    customDeckId
    notation {
      id
      type
      description
      status
      pageId
      coordinate {
        x
        y
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    status
    type
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserNotationsSubscriptionVariables,
  APITypes.OnDeleteUserNotationsSubscription
>;
export const onCreateCustomDeck = /* GraphQL */ `subscription OnCreateCustomDeck(
  $filter: ModelSubscriptionCustomDeckFilterInput
  $createdBy: String
) {
  onCreateCustomDeck(filter: $filter, createdBy: $createdBy) {
    id
    createdAt
    createdBy
    autoUpdateAcknowledgedAt
    updatedAt
    updatedBy
    tenantId
    groups {
      id
      pages {
        pageId
        pageNumber
        documentVersionId
        __typename
      }
      visible
      srcId
      docAccessLevel
      name
      locked
      __typename
    }
    title
    editMutex {
      userId
      timeStarted
      lastSeenAt
      __typename
    }
    sourceCustomDeckId
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCustomDeckSubscriptionVariables,
  APITypes.OnCreateCustomDeckSubscription
>;
export const onUpdateCustomDeck = /* GraphQL */ `subscription OnUpdateCustomDeck(
  $filter: ModelSubscriptionCustomDeckFilterInput
  $createdBy: String
) {
  onUpdateCustomDeck(filter: $filter, createdBy: $createdBy) {
    id
    createdAt
    createdBy
    autoUpdateAcknowledgedAt
    updatedAt
    updatedBy
    tenantId
    groups {
      id
      pages {
        pageId
        pageNumber
        documentVersionId
        __typename
      }
      visible
      srcId
      docAccessLevel
      name
      locked
      __typename
    }
    title
    editMutex {
      userId
      timeStarted
      lastSeenAt
      __typename
    }
    sourceCustomDeckId
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCustomDeckSubscriptionVariables,
  APITypes.OnUpdateCustomDeckSubscription
>;
export const onDeleteCustomDeck = /* GraphQL */ `subscription OnDeleteCustomDeck(
  $filter: ModelSubscriptionCustomDeckFilterInput
  $createdBy: String
) {
  onDeleteCustomDeck(filter: $filter, createdBy: $createdBy) {
    id
    createdAt
    createdBy
    autoUpdateAcknowledgedAt
    updatedAt
    updatedBy
    tenantId
    groups {
      id
      pages {
        pageId
        pageNumber
        documentVersionId
        __typename
      }
      visible
      srcId
      docAccessLevel
      name
      locked
      __typename
    }
    title
    editMutex {
      userId
      timeStarted
      lastSeenAt
      __typename
    }
    sourceCustomDeckId
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCustomDeckSubscriptionVariables,
  APITypes.OnDeleteCustomDeckSubscription
>;
export const onCreateFolder = /* GraphQL */ `subscription OnCreateFolder(
  $filter: ModelSubscriptionFolderFilterInput
  $createdBy: String
) {
  onCreateFolder(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    name
    isPinned
    status
    items {
      id
      type
      itemId
      status
      addedAt
      updateAcknowledgedAt
      itemLastUpdatedAt
      visiblePages
      customTitle
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    sharePermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    shareStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateFolderSubscriptionVariables,
  APITypes.OnCreateFolderSubscription
>;
export const onUpdateFolder = /* GraphQL */ `subscription OnUpdateFolder(
  $filter: ModelSubscriptionFolderFilterInput
  $createdBy: String
) {
  onUpdateFolder(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    name
    isPinned
    status
    items {
      id
      type
      itemId
      status
      addedAt
      updateAcknowledgedAt
      itemLastUpdatedAt
      visiblePages
      customTitle
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    sharePermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    shareStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateFolderSubscriptionVariables,
  APITypes.OnUpdateFolderSubscription
>;
export const onDeleteFolder = /* GraphQL */ `subscription OnDeleteFolder(
  $filter: ModelSubscriptionFolderFilterInput
  $createdBy: String
) {
  onDeleteFolder(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    name
    isPinned
    status
    items {
      id
      type
      itemId
      status
      addedAt
      updateAcknowledgedAt
      itemLastUpdatedAt
      visiblePages
      customTitle
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    sharePermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    shareStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteFolderSubscriptionVariables,
  APITypes.OnDeleteFolderSubscription
>;
export const onCreateContentShare = /* GraphQL */ `subscription OnCreateContentShare(
  $filter: ModelSubscriptionContentShareFilterInput
  $createdBy: String
) {
  onCreateContentShare(filter: $filter, createdBy: $createdBy) {
    id
    token
    tenantId
    type
    contentId
    meetingId
    expiresAt
    createdAt
    updatedAt
    createdBy
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    pageSettings {
      pageId
      hidden
      __typename
    }
    revoked
    customDeckDependencies {
      versions
      folderId
      __typename
    }
    notificationScope
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateContentShareSubscriptionVariables,
  APITypes.OnCreateContentShareSubscription
>;
export const onUpdateContentShare = /* GraphQL */ `subscription OnUpdateContentShare(
  $filter: ModelSubscriptionContentShareFilterInput
  $createdBy: String
) {
  onUpdateContentShare(filter: $filter, createdBy: $createdBy) {
    id
    token
    tenantId
    type
    contentId
    meetingId
    expiresAt
    createdAt
    updatedAt
    createdBy
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    pageSettings {
      pageId
      hidden
      __typename
    }
    revoked
    customDeckDependencies {
      versions
      folderId
      __typename
    }
    notificationScope
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateContentShareSubscriptionVariables,
  APITypes.OnUpdateContentShareSubscription
>;
export const onDeleteContentShare = /* GraphQL */ `subscription OnDeleteContentShare(
  $filter: ModelSubscriptionContentShareFilterInput
  $createdBy: String
) {
  onDeleteContentShare(filter: $filter, createdBy: $createdBy) {
    id
    token
    tenantId
    type
    contentId
    meetingId
    expiresAt
    createdAt
    updatedAt
    createdBy
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    pageSettings {
      pageId
      hidden
      __typename
    }
    revoked
    customDeckDependencies {
      versions
      folderId
      __typename
    }
    notificationScope
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteContentShareSubscriptionVariables,
  APITypes.OnDeleteContentShareSubscription
>;
export const onCreateIntegrationLog = /* GraphQL */ `subscription OnCreateIntegrationLog(
  $filter: ModelSubscriptionIntegrationLogFilterInput
) {
  onCreateIntegrationLog(filter: $filter) {
    integrationId
    id
    log {
      level
      timestamp
      message
      srcDocId
      srcDocVersion
      __typename
    }
    status
    tenantId
    createdAt
    updatedAt
    purgeAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateIntegrationLogSubscriptionVariables,
  APITypes.OnCreateIntegrationLogSubscription
>;
export const onUpdateIntegrationLog = /* GraphQL */ `subscription OnUpdateIntegrationLog(
  $filter: ModelSubscriptionIntegrationLogFilterInput
) {
  onUpdateIntegrationLog(filter: $filter) {
    integrationId
    id
    log {
      level
      timestamp
      message
      srcDocId
      srcDocVersion
      __typename
    }
    status
    tenantId
    createdAt
    updatedAt
    purgeAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateIntegrationLogSubscriptionVariables,
  APITypes.OnUpdateIntegrationLogSubscription
>;
export const onDeleteIntegrationLog = /* GraphQL */ `subscription OnDeleteIntegrationLog(
  $filter: ModelSubscriptionIntegrationLogFilterInput
) {
  onDeleteIntegrationLog(filter: $filter) {
    integrationId
    id
    log {
      level
      timestamp
      message
      srcDocId
      srcDocVersion
      __typename
    }
    status
    tenantId
    createdAt
    updatedAt
    purgeAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteIntegrationLogSubscriptionVariables,
  APITypes.OnDeleteIntegrationLogSubscription
>;
export const onCreateIntegrationSettings = /* GraphQL */ `subscription OnCreateIntegrationSettings(
  $filter: ModelSubscriptionIntegrationSettingsFilterInput
) {
  onCreateIntegrationSettings(filter: $filter) {
    id
    tenantId
    syncContentEvery
    name
    mapping {
      key
      fieldType
      dataType
      targetFieldName
      srcFieldname
      valueMappings {
        srcValue
        targetValue
        __typename
      }
      __typename
    }
    clientConfigurationFields {
      key
      value
      __typename
    }
    integrationType
    enabled
    notificationEmail
    errorSyncEmail
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateIntegrationSettingsSubscriptionVariables,
  APITypes.OnCreateIntegrationSettingsSubscription
>;
export const onUpdateIntegrationSettings = /* GraphQL */ `subscription OnUpdateIntegrationSettings(
  $filter: ModelSubscriptionIntegrationSettingsFilterInput
) {
  onUpdateIntegrationSettings(filter: $filter) {
    id
    tenantId
    syncContentEvery
    name
    mapping {
      key
      fieldType
      dataType
      targetFieldName
      srcFieldname
      valueMappings {
        srcValue
        targetValue
        __typename
      }
      __typename
    }
    clientConfigurationFields {
      key
      value
      __typename
    }
    integrationType
    enabled
    notificationEmail
    errorSyncEmail
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateIntegrationSettingsSubscriptionVariables,
  APITypes.OnUpdateIntegrationSettingsSubscription
>;
export const onDeleteIntegrationSettings = /* GraphQL */ `subscription OnDeleteIntegrationSettings(
  $filter: ModelSubscriptionIntegrationSettingsFilterInput
) {
  onDeleteIntegrationSettings(filter: $filter) {
    id
    tenantId
    syncContentEvery
    name
    mapping {
      key
      fieldType
      dataType
      targetFieldName
      srcFieldname
      valueMappings {
        srcValue
        targetValue
        __typename
      }
      __typename
    }
    clientConfigurationFields {
      key
      value
      __typename
    }
    integrationType
    enabled
    notificationEmail
    errorSyncEmail
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteIntegrationSettingsSubscriptionVariables,
  APITypes.OnDeleteIntegrationSettingsSubscription
>;
export const onCreateTrainingEvent = /* GraphQL */ `subscription OnCreateTrainingEvent(
  $filter: ModelSubscriptionTrainingEventFilterInput
) {
  onCreateTrainingEvent(filter: $filter) {
    id
    tenantId
    startDateTime
    endDateTime
    title
    trainingEventUsers {
      userId
      email
      givenName
      familyName
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    deleted
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTrainingEventSubscriptionVariables,
  APITypes.OnCreateTrainingEventSubscription
>;
export const onUpdateTrainingEvent = /* GraphQL */ `subscription OnUpdateTrainingEvent(
  $filter: ModelSubscriptionTrainingEventFilterInput
) {
  onUpdateTrainingEvent(filter: $filter) {
    id
    tenantId
    startDateTime
    endDateTime
    title
    trainingEventUsers {
      userId
      email
      givenName
      familyName
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    deleted
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTrainingEventSubscriptionVariables,
  APITypes.OnUpdateTrainingEventSubscription
>;
export const onDeleteTrainingEvent = /* GraphQL */ `subscription OnDeleteTrainingEvent(
  $filter: ModelSubscriptionTrainingEventFilterInput
) {
  onDeleteTrainingEvent(filter: $filter) {
    id
    tenantId
    startDateTime
    endDateTime
    title
    trainingEventUsers {
      userId
      email
      givenName
      familyName
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    deleted
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTrainingEventSubscriptionVariables,
  APITypes.OnDeleteTrainingEventSubscription
>;
export const onCreateMeeting = /* GraphQL */ `subscription OnCreateMeeting(
  $filter: ModelSubscriptionMeetingFilterInput
  $createdBy: String
) {
  onCreateMeeting(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    title
    startTime
    endTime
    contentPresented {
      contentId
      groupId
      folderItemId
      title
      groupTitle
      status
      contentType
      events {
        pageNumber
        pageId
        timestamp
        end
        __typename
      }
      openedAt
      closedAt
      presentedMeta {
        pageId
        presented
        followUp
        sentiment
        note
        title
        __typename
      }
      __typename
    }
    type
    fieldValues {
      fieldId
      valueOrId
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    notes
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    attendees {
      id
      name
      status
      updatedAt
      email
      crmAccountId
      crmAddressId
      crmUserId
      attendeeType
      crmRecord {
        crmCallId
        crmCallName
        crmCustomValues {
          fieldId
          objectRecords {
            id
            externalId
            syncStatus
            status
            values {
              fieldId
              values
              __typename
            }
            __typename
          }
          values
          __typename
        }
        crmSyncStatus
        lastSyncedAt
        __typename
      }
      lastSyncedAt
      __typename
    }
    crmRecord {
      crmCallId
      crmCallName
      crmCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      crmSyncStatus
      lastSyncedAt
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMeetingSubscriptionVariables,
  APITypes.OnCreateMeetingSubscription
>;
export const onUpdateMeeting = /* GraphQL */ `subscription OnUpdateMeeting(
  $filter: ModelSubscriptionMeetingFilterInput
  $createdBy: String
) {
  onUpdateMeeting(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    title
    startTime
    endTime
    contentPresented {
      contentId
      groupId
      folderItemId
      title
      groupTitle
      status
      contentType
      events {
        pageNumber
        pageId
        timestamp
        end
        __typename
      }
      openedAt
      closedAt
      presentedMeta {
        pageId
        presented
        followUp
        sentiment
        note
        title
        __typename
      }
      __typename
    }
    type
    fieldValues {
      fieldId
      valueOrId
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    notes
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    attendees {
      id
      name
      status
      updatedAt
      email
      crmAccountId
      crmAddressId
      crmUserId
      attendeeType
      crmRecord {
        crmCallId
        crmCallName
        crmCustomValues {
          fieldId
          objectRecords {
            id
            externalId
            syncStatus
            status
            values {
              fieldId
              values
              __typename
            }
            __typename
          }
          values
          __typename
        }
        crmSyncStatus
        lastSyncedAt
        __typename
      }
      lastSyncedAt
      __typename
    }
    crmRecord {
      crmCallId
      crmCallName
      crmCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      crmSyncStatus
      lastSyncedAt
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMeetingSubscriptionVariables,
  APITypes.OnUpdateMeetingSubscription
>;
export const onDeleteMeeting = /* GraphQL */ `subscription OnDeleteMeeting(
  $filter: ModelSubscriptionMeetingFilterInput
  $createdBy: String
) {
  onDeleteMeeting(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    title
    startTime
    endTime
    contentPresented {
      contentId
      groupId
      folderItemId
      title
      groupTitle
      status
      contentType
      events {
        pageNumber
        pageId
        timestamp
        end
        __typename
      }
      openedAt
      closedAt
      presentedMeta {
        pageId
        presented
        followUp
        sentiment
        note
        title
        __typename
      }
      __typename
    }
    type
    fieldValues {
      fieldId
      valueOrId
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    notes
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    attendees {
      id
      name
      status
      updatedAt
      email
      crmAccountId
      crmAddressId
      crmUserId
      attendeeType
      crmRecord {
        crmCallId
        crmCallName
        crmCustomValues {
          fieldId
          objectRecords {
            id
            externalId
            syncStatus
            status
            values {
              fieldId
              values
              __typename
            }
            __typename
          }
          values
          __typename
        }
        crmSyncStatus
        lastSyncedAt
        __typename
      }
      lastSyncedAt
      __typename
    }
    crmRecord {
      crmCallId
      crmCallName
      crmCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      crmSyncStatus
      lastSyncedAt
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMeetingSubscriptionVariables,
  APITypes.OnDeleteMeetingSubscription
>;
export const onCreateHub = /* GraphQL */ `subscription OnCreateHub(
  $filter: ModelSubscriptionHubFilterInput
  $createdBy: String
) {
  onCreateHub(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    name
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    hubSections {
      id
      sectionHeader
      status
      type
      visible
      order
      textarea {
        content
        __typename
      }
      sharedFiles {
        id
        contentId
        title
        contentType
        documentVersionSettings {
          associatedFiles {
            associatedFileId
            versionId
            notation {
              id
              type
              description
              status
              pageId
              coordinate {
                x
                y
                __typename
              }
              createdAt
              createdBy
              updatedAt
              updatedBy
              __typename
            }
            __typename
          }
          __typename
        }
        status
        order
        createdAt
        updatedAt
        notation {
          id
          type
          description
          status
          pageId
          coordinate {
            x
            y
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          __typename
        }
        pageSettings {
          pageId
          hidden
          __typename
        }
        pageGroups {
          id
          pageIds
          name
          locked
          sourceID
          source
          __typename
        }
        renderInline
        __typename
      }
      toDos {
        id
        title
        status
        completedAt
        resolution
        order
        createdAt
        updatedAt
        __typename
      }
      links {
        id
        url
        title
        status
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      locked
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    meetingId
    templateId
    copiedFromHubId
    editPermissions
    readPermissions
    sharedPermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    hubType
    lockName
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateHubSubscriptionVariables,
  APITypes.OnCreateHubSubscription
>;
export const onUpdateHub = /* GraphQL */ `subscription OnUpdateHub(
  $filter: ModelSubscriptionHubFilterInput
  $createdBy: String
) {
  onUpdateHub(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    name
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    hubSections {
      id
      sectionHeader
      status
      type
      visible
      order
      textarea {
        content
        __typename
      }
      sharedFiles {
        id
        contentId
        title
        contentType
        documentVersionSettings {
          associatedFiles {
            associatedFileId
            versionId
            notation {
              id
              type
              description
              status
              pageId
              coordinate {
                x
                y
                __typename
              }
              createdAt
              createdBy
              updatedAt
              updatedBy
              __typename
            }
            __typename
          }
          __typename
        }
        status
        order
        createdAt
        updatedAt
        notation {
          id
          type
          description
          status
          pageId
          coordinate {
            x
            y
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          __typename
        }
        pageSettings {
          pageId
          hidden
          __typename
        }
        pageGroups {
          id
          pageIds
          name
          locked
          sourceID
          source
          __typename
        }
        renderInline
        __typename
      }
      toDos {
        id
        title
        status
        completedAt
        resolution
        order
        createdAt
        updatedAt
        __typename
      }
      links {
        id
        url
        title
        status
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      locked
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    meetingId
    templateId
    copiedFromHubId
    editPermissions
    readPermissions
    sharedPermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    hubType
    lockName
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateHubSubscriptionVariables,
  APITypes.OnUpdateHubSubscription
>;
export const onDeleteHub = /* GraphQL */ `subscription OnDeleteHub(
  $filter: ModelSubscriptionHubFilterInput
  $createdBy: String
) {
  onDeleteHub(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    name
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    hubSections {
      id
      sectionHeader
      status
      type
      visible
      order
      textarea {
        content
        __typename
      }
      sharedFiles {
        id
        contentId
        title
        contentType
        documentVersionSettings {
          associatedFiles {
            associatedFileId
            versionId
            notation {
              id
              type
              description
              status
              pageId
              coordinate {
                x
                y
                __typename
              }
              createdAt
              createdBy
              updatedAt
              updatedBy
              __typename
            }
            __typename
          }
          __typename
        }
        status
        order
        createdAt
        updatedAt
        notation {
          id
          type
          description
          status
          pageId
          coordinate {
            x
            y
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          __typename
        }
        pageSettings {
          pageId
          hidden
          __typename
        }
        pageGroups {
          id
          pageIds
          name
          locked
          sourceID
          source
          __typename
        }
        renderInline
        __typename
      }
      toDos {
        id
        title
        status
        completedAt
        resolution
        order
        createdAt
        updatedAt
        __typename
      }
      links {
        id
        url
        title
        status
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      locked
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    meetingId
    templateId
    copiedFromHubId
    editPermissions
    readPermissions
    sharedPermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    hubType
    lockName
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteHubSubscriptionVariables,
  APITypes.OnDeleteHubSubscription
>;
export const onCreateCustomFormRecord = /* GraphQL */ `subscription OnCreateCustomFormRecord(
  $filter: ModelSubscriptionCustomFormRecordFilterInput
  $createdBy: String
) {
  onCreateCustomFormRecord(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    customFormId
    entity
    status
    crmFields {
      accountId
      externalId
      apiName
      recordTypeId
      syncStatus
      lastSyncedAt
      __typename
    }
    name
    parentId
    parentModel
    values {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCustomFormRecordSubscriptionVariables,
  APITypes.OnCreateCustomFormRecordSubscription
>;
export const onUpdateCustomFormRecord = /* GraphQL */ `subscription OnUpdateCustomFormRecord(
  $filter: ModelSubscriptionCustomFormRecordFilterInput
  $createdBy: String
) {
  onUpdateCustomFormRecord(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    customFormId
    entity
    status
    crmFields {
      accountId
      externalId
      apiName
      recordTypeId
      syncStatus
      lastSyncedAt
      __typename
    }
    name
    parentId
    parentModel
    values {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCustomFormRecordSubscriptionVariables,
  APITypes.OnUpdateCustomFormRecordSubscription
>;
export const onDeleteCustomFormRecord = /* GraphQL */ `subscription OnDeleteCustomFormRecord(
  $filter: ModelSubscriptionCustomFormRecordFilterInput
  $createdBy: String
) {
  onDeleteCustomFormRecord(filter: $filter, createdBy: $createdBy) {
    id
    tenantId
    customFormId
    entity
    status
    crmFields {
      accountId
      externalId
      apiName
      recordTypeId
      syncStatus
      lastSyncedAt
      __typename
    }
    name
    parentId
    parentModel
    values {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCustomFormRecordSubscriptionVariables,
  APITypes.OnDeleteCustomFormRecordSubscription
>;
export const onCreatePromptValues = /* GraphQL */ `subscription OnCreatePromptValues(
  $filter: ModelSubscriptionPromptValuesFilterInput
  $tenantId: String
) {
  onCreatePromptValues(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    promptType
    status
    value
    editPermissions
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePromptValuesSubscriptionVariables,
  APITypes.OnCreatePromptValuesSubscription
>;
export const onUpdatePromptValues = /* GraphQL */ `subscription OnUpdatePromptValues(
  $filter: ModelSubscriptionPromptValuesFilterInput
  $tenantId: String
) {
  onUpdatePromptValues(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    promptType
    status
    value
    editPermissions
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePromptValuesSubscriptionVariables,
  APITypes.OnUpdatePromptValuesSubscription
>;
export const onDeletePromptValues = /* GraphQL */ `subscription OnDeletePromptValues(
  $filter: ModelSubscriptionPromptValuesFilterInput
  $tenantId: String
) {
  onDeletePromptValues(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    promptType
    status
    value
    editPermissions
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePromptValuesSubscriptionVariables,
  APITypes.OnDeletePromptValuesSubscription
>;
export const onCreateBulletin = /* GraphQL */ `subscription OnCreateBulletin(
  $filter: ModelSubscriptionBulletinFilterInput
  $tenantId: String
) {
  onCreateBulletin(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    title
    content
    status
    publishedAt
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBulletinSubscriptionVariables,
  APITypes.OnCreateBulletinSubscription
>;
export const onUpdateBulletin = /* GraphQL */ `subscription OnUpdateBulletin(
  $filter: ModelSubscriptionBulletinFilterInput
  $tenantId: String
) {
  onUpdateBulletin(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    title
    content
    status
    publishedAt
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBulletinSubscriptionVariables,
  APITypes.OnUpdateBulletinSubscription
>;
export const onDeleteBulletin = /* GraphQL */ `subscription OnDeleteBulletin(
  $filter: ModelSubscriptionBulletinFilterInput
  $tenantId: String
) {
  onDeleteBulletin(filter: $filter, tenantId: $tenantId) {
    id
    tenantId
    title
    content
    status
    publishedAt
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBulletinSubscriptionVariables,
  APITypes.OnDeleteBulletinSubscription
>;
export const onCsvExportReady = /* GraphQL */ `subscription OnCsvExportReady($userId: ID!) {
  onCsvExportReady(userId: $userId) {
    userId
    signedUrl
    queryExecutionId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCsvExportReadySubscriptionVariables,
  APITypes.OnCsvExportReadySubscription
>;
export const onLangflowResponse = /* GraphQL */ `subscription OnLangflowResponse($userId: ID!, $sessionId: String!) {
  onLangflowResponse(userId: $userId, sessionId: $sessionId) {
    tenantId
    userId
    sessionId
    status
    statusDetail
    response
    metadata
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnLangflowResponseSubscriptionVariables,
  APITypes.OnLangflowResponseSubscription
>;
